import { createFilterConfig } from '@/Components/filterbar';
import { requireUserCaps } from '@/Router';
import { HubsQuery, type Hubs_Query } from '@/graphql/queries/Hub.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
export const HubsFilterConfig = createFilterConfig({
  routeId: '/dash/hubs/hubs/',
  options: {
    restoreOnMount: true
  }
}, {
  search: true,
  visibility: true,
  author: true,
  order: true,
  date: true,
  hubTemplate: true,
  hubGroup: true,
  hubFilter: true
});
export const Route = createFileRoute('/dash/hubs/hubs/')({
  validateSearch: HubsFilterConfig.filterSearchValidator,
  loader: () => {
    return loadQuery<Hubs_Query>(RelayEnvironment, HubsQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  },
  beforeLoad() {
    requireUserCaps(['read_hub'], {
      to: '/dash/catalog'
    });
  }
});